import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index/index'
import custom from '@/page/iframe'
import Buildsolution from '@/page/yuqingFenxi/buildSolution'
import monitoring from '@/page/yuqingFenxi/monitoring'
import informationSet from '@/page/yuqingFenxi/informationSet'
import sourceCenter from '@/page/yuqingFenxi/sourceCenter'
import allInformationSet from '@/page/yuqingFenxi/allInformationSet'
import monitoringDet from '@/page/yuqingFenxi/monitoringDet'
import similarArticles from '@/page/yuqingFenxi/similarArticles'
import yuYingGather from '@/page/yuqingFenxi/yuYingGather'
import detail from '@/page/yuqingFenxi/detail'
import yuJinCenter from '@/page/yuqingFenxi/yuJinCenter'
import receiveSet from '@/page/personalCenter/receiveSet'
import presentationCenter from '@/page/yuqingFenxi/presentation/presentationCenter'
import timingTemplate from '@/page/yuqingFenxi/presentation/timingTemplate'
import addTimingTemplate from '@/page/yuqingFenxi/presentation/addTimingTemplate'
import ordinaryTemplate from '@/page/yuqingFenxi/presentation/ordinaryTemplate'
import addOrdinaryTemplate from '@/page/yuqingFenxi/presentation/addOrdinaryTemplate'
import addNewOrdinaryTemplate from '@/page/yuqingFenxi/presentation/addNewOrdinaryTemplate'
import timelyReporting from '@/page/yuqingFenxi/presentation/timelyReporting'
import intelligenceYuJin from '@/page/yuqingFenxi/intelligenceYuJin'
import sourceSet from '@/page/yuqingFenxi/sourceSet'
/*传播分析*/
import allAnalysis from '@/page/yuqingFenxi/propagationAnalysis/allAnalysis' 
import webAnalysis from '@/page/yuqingFenxi/propagationAnalysis/webAnalysis' 
import wxAnalysis from '@/page/yuqingFenxi/propagationAnalysis/wxAnalysis' 
import wbAnalysis from '@/page/yuqingFenxi/propagationAnalysis/wbAnalysis' 
import ttAnalysis from '@/page/yuqingFenxi/propagationAnalysis/ttAnalysis' 
import shAnalysis from '@/page/yuqingFenxi/propagationAnalysis/shAnalysis' //搜狐
import dyAnalysis from '@/page/yuqingFenxi/propagationAnalysis/dyAnalysis' //抖音
import appAnalysis from '@/page/yuqingFenxi/propagationAnalysis/appAnalysis' //app
import analysisDetail from '@/page/yuqingFenxi/propagationAnalysis/analysisDetail' //app
import propagationPath from '@/page/yuqingFenxi/propagationPath' //传播路径
import hotarticlesDetail from '@/page/yuqingFenxi/propagationAnalysis/hotarticlesDetail' //传播路径
/*个人中心*/
import vipRight from '@/page/personalCenter/vipRight'
import systemSettings from '@/page/personalCenter/systemSettings'
import myCollect from '@/page/personalCenter/myCollect'
import myDownload from '@/page/personalCenter/myDownload'
import changePassword from '@/page/personalCenter/changePassword'
import addData from '@/page/personalCenter/addData'
import userManage from '@/page/personalCenter/userManage'
//热点事件
import eventsIndex from '@/page/hotSpotEvents/eventsIndex'
import eventDetail from '@/page/hotSpotEvents/eventDetail'
//竞对报告
import competingReport from '@/page/competingReports/competingReport'
import customTemplate from '@/page/competingReports/customTemplate'
import competDetail from '@/page/competingReports/competDetail'
import addCustomTemplate from '@/page/competingReports/addCustomTemplate'
import fullTextDetail from '@/page/productCenter/detail'
import addNewCustomTemplate from '@/page/competingReports/addNewCustomTemplate'
//方案选择
import plan from '@/page/index/plan'
import eventsPath from '@/page/eventsPath'
//产品中心
import eventsInfomation from '@/page/productCenter/eventsInfomation'
import eventsHtml from '@/page/productCenter/eventsHtml'
import detailInformation from '@/page/productCenter/detailInformation'

Vue.use(Router)
export default new Router({
    // pageType判断页面属于哪个导航分类
    // keepAlive 不同页面的头部颜色 首页1 
    // leftShow 是否有左侧导航
    mode: 'history',  //去掉url中的#
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
            meta:{
                title:'舆情分析系统_互联网大数据分析平台',
                requireAuth: false,//登录状态
                leftShow:false,
                keepAlive:3,
                planCut:false//方案无需检测
            }
        },
        {
            path: '/custom',
            name: 'custom',
            component: custom,
            meta:{
                title:'',
                requireAuth: true,//登录状态
                leftShow:false,
                keepAlive:3,
                planCut:false//方案无需检测
            }
        },
        /** 舆情分析*/
        {
            path: '/analysis',
            redirect: '/analysis/yuYingGather',
            name: '舆情总揽',
            component: yuYingGather,
            meta:{
                title:'舆情总览_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
			path: '/analysis/intelligenceYuJin',
			name: '智能预警',
			component: intelligenceYuJin,
			meta: {
				title: '智能预警',
				requireAuth: true, //登录状态
				leftShow: true,
				keepAlive: 2,
				planCut: true, //方案检测
				pageType: 0
			}
		},
        {
            path: '/analysis/buildSolution',
            name: 'buildSolution',
            component: Buildsolution,
            meta:{
                title:'创建方案_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:0
            }
        },
        {
            path: '/monitoring',
            name: 'monitoring',
            component: monitoring,
            meta:{
                title: '定向信源_',
				requireAuth: true, //登录状态+
				leftShow: false,
                keepAlive: 3,
                pageType: 9,
				planCut: false //方案无需检测
            }
        },
        {
			path: '/monitoring/sourceSet',
			name: 'sourceSet',
			component: sourceSet,
			meta: {
				title: '信源设置_',
				requireAuth: true, //登录状态+
				leftShow: false,
                keepAlive: 3,
                pageType: 9,
				planCut: false //方案无需检测
			}
        },
        {
			path: '/monitoringDet',
			name: 'monitoringDet',
			component: monitoringDet,
			meta: {
				title: '定向信源_',
				requireAuth: true, //登录状态+
				leftShow: false,
                keepAlive: 3,
                pageType: 9,
				planCut: false //方案无需检测
			}
        },
        {
            path: '/analysis/informationSet',
            name: '信息汇总',
            component: informationSet,
            meta:{
                title:'信息汇总_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
            path: '/analysis/sourceCenter',
            name: '信源中心',
            component: sourceCenter,
            meta:{
                title:'信源中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
            path: '/analysis/similarArticles',
            name: '相似',
            component: similarArticles,
            meta:{
                title:'信息列表_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
			path: '/analysis/allAnalysis/hotarticlesDetail',
			name: '传播分析-热门文章',
			component: hotarticlesDetail,
			meta: {
				title: '传播分析_',
				requireAuth: true, //登录状态
				leftShow: true,
				keepAlive: 2,
				planCut: true, //方案检测
				pageType: 0,
				shuYu: 'propagationAnalysis' //所属
			}
		},
        {
            path: '/detail',
            name: '信息汇总详情',
            component: detail,
            meta:{
                title:'信息详情_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
            path: '/analysis/allAnalysis',
            name: '传播分析',
            component: allAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/propagationPath',
            name: '传播路径',
            component: propagationPath,
            meta:{
                title:'传播路径_',
                requireAuth: true,//登录状态
                leftShow:false,
                keepAlive:3,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/webAnalysis',
            name: '传播分析-网页-论坛-问答',
            component: webAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/wxAnalysis',
            name: '传播分析-微信',
            component: wxAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/wbAnalysis',
            name: '传播分析-微博',
            component: wbAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/ttAnalysis',
            name: '传播分析-头条',
            component: ttAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/shAnalysis',
            name: '传播分析-搜狐',
            component: shAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/dyAnalysis',
            name: '传播分析-抖音-快手',
            component: dyAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/allAnalysis/appAnalysis',
            name: '传播分析-app',
            component: appAnalysis,
            meta:{
                title:'传播分析_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/analysisDetail',
            name: '传播分析-详情',
            component: analysisDetail,
            meta:{
                title:'信息列表_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'propagationAnalysis'//所属
            }
        },
        {
            path: '/analysis/yuJinCenter',
            name: '预警中心',
            component: yuJinCenter,
            meta:{
                title:'预警中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
            path: '/analysis/presentationCenter',
            name: '报告中心',
            component: presentationCenter,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            },
        },
        {
            path: '/analysis/timingTemplate',
            name: '定时模板',
            component: timingTemplate,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },{
            path: '/analysis/timelyReporting',
            name: '定时模板',
            component: timelyReporting,
            meta:{
                title:'报告中心_',
                keepAlive:2,
                requireAuth: true,//登录状态
                leftShow:true,
                planCut:true,//方案无需检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },
        {
            path: '/analysis/addTimingTemplate',
            name: '新增定时模板',
            component: addTimingTemplate,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },
        {
            path: '/analysis/ordinaryTemplate',
            name: '普通模板',
            component: ordinaryTemplate,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },
        {
            path: '/analysis/addOrdinaryTemplate',
            name: '新建普通模板',
            component: addOrdinaryTemplate,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },
        {
            path: '/analysis/addNewOrdinaryTemplate',
            name: '新建普通模板',
            component: addNewOrdinaryTemplate,
            meta:{
                title:'报告中心_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0,
                shuYu:'presentation'//所属
            }
        },
        {
            path: '/analysis/yuYingGather',
            name: '舆情总揽',
            component: yuYingGather,
            meta:{
                title:'舆情总览_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:true,//方案检测
                pageType:0
            }
        },
        {
            path: '/allInformationSet',
            name: '信息汇总',
            component: allInformationSet,
            meta:{
                title:'信息汇总_',
                requireAuth: true,//登录状态
                leftShow:true,
                // keepAlive:2,
                planCut:true,//方案检测
                pageType:6
            }
        },
        /** 个人中心*/
        {
            path: '/vipRight',
            name: '会员权益',
            component: vipRight,
            meta:{
                title:'我的会员_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:4,
                shuYu:'vip'//所属
            }
        },
        // {
        //     path: '/renew',
        //     name: '会员续费',
        //     component: renew,
        //     meta:{
        //         title:'会员续费_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        // {
        //     path: '/vipBuy',
        //     name: '会员续费',
        //     component: vipBuy,
        //     meta:{
        //         title:'会员购买_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        // {
        //     path: '/vipExchange',
        //     name: '会员购买',
        //     component: vipExchange,
        //     meta:{
        //         title:'会员购买_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        // {
        //     path: '/duanXinRecharge',
        //     name: '短信充值',
        //     component: duanXinRecharge,
        //     meta:{
        //         title:'短信充值_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        // {
        //     path: '/downloadBuy',
        //     name: '下载量购买',
        //     component: downloadBuy,
        //     meta:{
        //         title:'下载量购买_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        // {
        //     path: '/rechargeRecord',
        //     name: '充值记录',
        //     component: rechargeRecord,
        //     meta:{
        //         title:'充值记录_',
        //         requireAuth: true,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:4,
        //         shuYu:'vip'//所属
        //     }
        // },
        {
            path: '/myCollect',
            name: '我的收藏',
            component: myCollect,
            meta:{
                title:'我的收藏_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:4
            }
        },
        {
            path: '/myDownload',
            name: '我的下载',
            component: myDownload,
            meta:{
                title:'我的下载_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:4
            }
        },
        {
			path:  '/addData',
			name: '数据补录',
			component: addData,
			meta: {
				title: '数据补录_',
				requireAuth: true, //登录状态
				leftShow: true,
				keepAlive: 2,
				planCut: false, //方案无需检测
				pageType: 4
			}
		},
        {
			path:  '/userManage',
			name: '用户管理',
			component: userManage,
			meta: {
				title: '用户管理_',
				requireAuth: true, //登录状态
				leftShow: true,
				keepAlive: 2,
				planCut: false, //方案无需检测
				pageType: 4
			}
		},
        {
            path: '/receiveSet',
            name: '联系人设置',
            component: receiveSet,
            meta:{
                title:'联系人设置_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:4
            }
        },
        {
            path: '/changePassword',
            name: '修改密码',
            component: changePassword,
            meta:{
                title:'在线反馈_',
                requireAuth: true,//登录状态
                leftShow:true,
                keepAlive:2,
                planCut:false,//方案无需检测
                pageType:4
            }
        },
        {
			path: '/systemSettings',
			name: '系统时间',
			component: systemSettings,
			meta: {
				title: '系统时间_',
				requireAuth: true, //登录状态
				leftShow: true,
				keepAlive: 2,
				planCut: false, //方案无需检测
				pageType: 4
			}
		},
        /** 热点事件*/
        {
            path: '/eventsIndex',
            name: '热点事件首页',
            component: eventsIndex,
            meta:{
                title:'热点事件_',
                requireAuth: true,//登录状态
                leftShow:false,
                keepAlive:3,
                planCut:false,//方案无需检测
                pageType:2
            }
        },
        // {
        //     path: '/eventsKu',
        //     name: '事件库',
        //     component: eventsKu,
        //     meta:{
        //         title:'事件库_',
        //         requireAuth: false,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:2
        //     }
        // },
        // {
        //     path: '/specialKu',
        //     name: '专题库',
        //     component: specialKu,
        //     meta:{
        //         title:'专题库_',
        //         requireAuth: false,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:2
        //     }
        // },
        {
            path: '/eventDetail',
            name: '事件详情',
            component: eventDetail,
            meta:{
                title:'事件详情_',
                requireAuth: false,//登录状态
                keepAlive:3,
                planCut:false,//方案无需检测
                pageType:2
            }
        },
        {
			path: '/eventsPath',
			name: '事件传播路径',
			component: eventsPath,
			meta: {
				title: '事件传播路径_',
				requireAuth: true, //登录状态
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 3
			}
        },
        {
			path: '/eventsInfomation',
			name: '事件信息列表',
			component: eventsInfomation,
			meta: {
				title: '事件传播分析_事件信息列表',
				requireAuth: true, //登录状态
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 3
			}
		},
        {
			path:'/detailInformation',
			name: '信息详情',
			component: detailInformation,
			meta: {
				title: '事件传播分析_信息详情',
				requireAuth: true, //登录状态
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 3
			}
        },
        {
			path: '/eventsHtml',
			name: '事件信息详情',
			component: eventsHtml,
			meta: {
				title: '事件传播分析_事件信息详情',
				requireAuth: true, //登录状态
                keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 3
			}
        },
        {
			path: '/fullTextDetail',
			name: '全文检索详情',
			component: fullTextDetail,
			meta: {
				title: '事件传播分析_全文检索详情',
				requireAuth: true, //登录状态
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 3
			}
        },
        // {
        //     path: '/specialDetail',
        //     name: '事件详情',
        //     component: specialDetail,
        //     meta:{
        //         title:'事件列表_',
        //         requireAuth: false,//登录状态
        //         leftShow:true,
        //         keepAlive:2,
        //         planCut:false,//方案无需检测
        //         pageType:2,
        //         shuYu:'eventSpecia'
        //     }
        // },
        /** 产品中心*/
        // {
        //     path: '/product',
        //     name: '产品中心',
        //     component: product,
        //     meta:{
        //         title:'事件传播分析_',
        //         requireAuth: true,//登录状态
        //         keepAlive:4,
        //         planCut:false,//方案无需检测
        //         pageType:3
        //     }
        // },
        // {
        //     path: '/productDetail',
        //     name: '产品中心',
        //     component: productDetail,
        //     meta:{
        //         title:'事件传播分析_',
        //         requireAuth: true,//登录状态
        //         keepAlive:3,
        //         planCut:false,//方案无需检测
        //         pageType:3
        //     }
        // },
        /** 竞对报告*/
        {
            path: '/competingReport',
            name: '竞对报告',
            component: competingReport,
            meta:{
                title:'竞对报告_',
                requireAuth: true,//登录状态
                leftShow:false,
                keepAlive:3,
                planCut:false,//方案无需检测
                pageType:5
            }
        },
        {
			path: '/customTemplate',
			name: '自定义竞对报告模板',
			component: customTemplate,
			meta: {
				title: '自定义竞对报告模板_',
				requireAuth: true, //登录状态
				leftShow: false,
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 5
			}
		},{
			path: '/addCustomTemplate',
			name: '新建自定义竞对报告模板',
			component: addCustomTemplate,
			meta: {
				title: '新建自定义竞对报告模板_',
				requireAuth: true, //登录状态
				leftShow: false,
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 5
			}
		},
        {
			path: '/addNewCustomTemplate',
			name: '新建自定义竞对报告模板',
			component: addNewCustomTemplate,
			meta: {
				title: '新建自定义竞对报告模板_',
				requireAuth: true, //登录状态
				leftShow: false,
				keepAlive: 3,
				planCut: false, //方案无需检测
				pageType: 5
			}
		},
        {
            path: '/competDetail',
            name: '竞对报告详情',
            component: competDetail,
            meta:{
                title:'竞对报告_',
                requireAuth: true,//登录状态
                keepAlive:3,
                planCut:false,//方案无需检测
                pageType:5
            }
        },
        {
            path: '/plan',
            name: '方案选择',
            component: plan,
            meta:{
                title:'方案选择',
                requireAuth: true,//登录状态
                keepAlive:3,
                planCut:false,//方案无需检测
                pageType:5
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js